import { makeLocalBusinessJsonLd } from '@utils/jsonLd/business';
import { makeOpeningHoursJsonLd } from '@utils/jsonLd/hours';
import { makeOrganizationJsonLd } from '@utils/jsonLd/organization';
import { RICH_FAQ_SKUS } from '@utils/jsonLd/constants';
import { makeRatingJsonLd } from '@utils/jsonLd/rating';
import { HT_INFO_PHONE } from '@constants/hellotech';

const makeSkuRating = (ratingAttributes) => {
  const attrs = ratingAttributes;
  if (attrs?.rating == null || attrs?.ratingCount == null) return '';
  return makeRatingJsonLd({ rating: attrs?.rating, count: attrs?.ratingCount });
};


export const makeRichFaqJsonLd = (sku) => {
  const hardcodedFAQ = RICH_FAQ_SKUS[sku.seoName];
  const faqs = hardcodedFAQ || (sku.faq || []);
  const faq = faqs.map(elem => ({
      "questionName": elem.question,
      "acceptedAnswerText": elem.answer
    }));

  return {
      "mainEntity": faq
    }
};

export const makeSkuJsonLd = (sku) => {
  const url = `https://www.hellotech.com/tech-support/${sku.seoName}`;
  return {
    "productName": sku.name,
    "award": "A+ Rating from the Better Business Bureau",
    "brand": "HelloTech",
    "description": sku.description,
    "images": [sku.image],
    ...makeSkuRating(sku),
  }
};

export const makeLocationSkuJsonLd = (sku, location, ratingAttributes, phone = HT_INFO_PHONE.customers.default.title) => {
  // const url = `https://www.hellotech.com${locationUrl(location)}/${sku.seoName}`;
  const description = `Order a ${sku.name} from HelloTech ${location.name}`; // name = is state or city, fully qualified
  return {
    "@context": "http://schema.org",
    ...makeLocalBusinessJsonLd(location.name, description, phone),
    ...makeOpeningHoursJsonLd(),
    "parentOrganization": {
      ...makeOrganizationJsonLd()
    },
    ...makeSkuRating(ratingAttributes),
    "address": '', // this is city, state (ie. Culver City, California)
  }
};
